import React, { Fragment, useRef } from 'react';
import { getRandomColor } from './DisputeImagesUtils';
import ImageLazyWrapper from './ImageLazyWrapper';
import Button from 'jd-library/Button';
import ScrollIndicators from '../../../../../common/ViewImage/ScrollIndicators';

import './order-attachments.scss';

const OrderAttachments = props => {
	const parentRef = useRef(null);

	let stylesObj = [];
	const imageListHtml = props.list.map((image, index) => {
		if(props.disputeRaised){
			image.extension = image.url.split('.').pop().toLowerCase();
		}
		if (image.tempSave && props.ignoreTemp) {
			return null;
		}
		if (image.tempDel && !props.ignoreTemp) {
			return null;
		}
		if (!stylesObj.index) {
			stylesObj[index] = {
				position: 'absolute',
				top: 0,
				left: 0,
				width: '100%',
				height: '100%',
				borderRadius: '4px',
				...getRandomColor(true)
			};
		}
		const imgToRight = props.viewIssue ? (index + 1) % 4 : (index + 1) % 3;
		const rightClass =
			props.viewIssue && !props.isMobile
				? 'view-issues-right-img'
				: props.viewIssue && props.isMobile
				? ''
				: 'right-end-img';
		return (
			<div
				className={`attachment-container ${
					imgToRight == 0 && !props.disputeRaised ? rightClass : ''
				} ${props.isMobile ? 'attachment-container-mob' : ''} ${
					image.loading ? 'loading-container' : ''
				} ${props.viewIssue ? 'view-issues' : ''} `}
				key={image.key || image.id}
			>
				{image.loading ? (
					<div className={`loader`}>
						<span className={`default-loader`}></span>
					</div>
				) : (
					<Fragment>
						{props.editable && !props.disputeRaised && (
							<span
								className='icon-close-thin attachment-delete'
								onClick={e =>
									props.onCross && props.onCross(e, index)
								}
							/>
						)}
						<div
							className={`image-preview-holder ${
								props.viewIssue ? 'view-issues-holder' : ''
							}`}
						>
							<React.Fragment>
								{/* <img src={image.url} /> */}
								<ImageLazyWrapper
									randomColorObj={stylesObj[index]}
									imageSrc={
										image.extension == 'pdf'
											? 'https://image1.jdomni.in/jdomni_email/pdfGraphic_1904091817.png'
											: image.url
									}
									imgClass='attachment-icon'
								/>
							</React.Fragment>
						</div>
						{!props.isMobile && (
							<span class='icon-zoomIn preview-icon'></span>
						)}
					</Fragment>
				)}
			</div>
		);
	});

	const Wrapper = Fragment;

	return (
		<Fragment>
			{props.disputeRaised && !props.isMobile ? <ScrollIndicators
				scrollContainerRef={parentRef}
				mediaLength={props.list.length}
			/>: null}
			<div
				className={`order-attachment-list ${
					imageListHtml.length === 0 ? 'no-attachments' : ''
				} ${props.className} ${
					props.viewIssue && props.isMobile ? 'horizontal-photo' : ''
				} ${props.disputeRaised ? 'show-slider' : 'grid-view'}`}
				ref={parentRef}
				body-scroll-lock-ignore='true'
			>
				{imageListHtml}
				{!props.disputeRaised ? (
					<>
						{props.editable &&
							imageListHtml.length < props.maxFiles && (
								<Wrapper
									containerRef={parentRef}
									className={'presc-pop'}
								>
									<div
										className={`add-attachment ${
											imageListHtml.length
												? 'right-end-img'
												: 'upload-btn-container'
										} ${
											props.isError ? 'upload-error' : ''
										}
										${props.isReadOnly ? 'add-attachment-right-end-img-read-only-mode' : ''}
										`}
										onClick={e => {
											if (props.isReadOnly) return;
											props.isMobile
												? props.onAdd(e, {
														value: e.key
												  })
												: props.popClickOptions(e, {
														value: 'gallery'
												  })
										}}
									>
										{imageListHtml.length === 0 && !props.customBtn ? (
											<span>
												<Button
													variant='default'
													className='upload-btn'
												>
													<Fragment>
														<i
															className={`icon-upload upload-icon-styling ${
																props.isMobile
																	? 'upload-icon-styling-mob'
																	: ''
															}`}
														/>{' '}
														<span
															className={
																'marginL5'
															}
														>
															{props.btnTxt ? props.btnTxt : 'Upload'}
														</span>
													</Fragment>
												</Button>
											</span>
										) : (
											<div className='add-prescription'>
												<i
													className={`icon-style icon-cameraNew`}
												></i>
												<div className='txt'>
													{props.customBtn ? props.customBtn.btnTxt:'Add'}
												</div>
											</div>
										)}
									</div>
								</Wrapper>
							)}
					</>
				) : null}
			</div>
		</Fragment>
	);
};

OrderAttachments.defaultProps = {
	maxFiles: 9,
	editable: false,
	list: [],
	className: ''
};

export default OrderAttachments;
